import { useEffect, useState } from "react";
import { fetchLocationPaymentOptions } from "../services/publicApi";

export function useLocationPaymentOptions(locationSlug) {
  const [paymentOptions, setPaymentOptions] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(Boolean(locationSlug));

  useEffect(() => {
    if (!locationSlug) {
      setPaymentOptions(null);
      setLoading(false);
      return undefined;
    }

    let isMounted = true;
    setLoading(true);
    setError("");

    async function loadPaymentOptions() {
      try {
        const payload = await fetchLocationPaymentOptions(locationSlug);

        if (isMounted) {
          setPaymentOptions(payload);
        }
      } catch (requestError) {
        if (isMounted) {
          setError(requestError.message || "We could not load payment options.");
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    }

    loadPaymentOptions();

    return () => {
      isMounted = false;
    };
  }, [locationSlug]);

  return {
    paymentOptions,
    loading,
    error,
  };
}
